<div mat-dialog-title style="font-size: 24px;">{{ data.attributeName }} History <span class="close" (click)="close()"
    style="position: absolute; top: 10px; right: 16px; font-size: 28px; cursor: pointer;">&times;</span>
</div>
<mat-dialog-content>
  <div *ngIf="sortedHistory && sortedHistory.length > 0">
    <ul class="insight-container" style="list-style: none; padding: 0; overflow-y: auto; margin-bottom: 12px;">
      <li *ngFor="let history of sortedHistory; let i = index" style="margin-bottom: 12px; border-radius: 10px; background: #f5f4ff;  border: 1px solid #7660ff; box-shadow: 0 1px 4px rgba(0,0,0,0.04); padding: 16px 16px 8px 16px;">
        <div class="history-block">
          <ul style="padding-left: 0; margin: 0; list-style: none;">
            <li style="margin-bottom: 4px; font-family: EYInterstate;">
              <div style="display: flex; align-items: center;">
              </div>
              <div>
                <ng-container *ngIf="(history.displayValue || '').length > 200">
                  <ng-container *ngIf="!expanded[i]">
                    <markdown class="history-markdown" [data]="htmlEscape(getTruncatedValue(history.displayValue))"></markdown>
                    <a href="#" (click)="$event.preventDefault(); toggleExpand(i)" style="color: #1976d2; margin-left: 8px; font-size: 12px; text-decoration: none; cursor: pointer;">
                      Show more
                    </a>
                  </ng-container>
                  <ng-container *ngIf="expanded[i]">
                    <markdown class="history-markdown" [data]="htmlEscape(history.displayValue)"></markdown>
                    <a href="#" (click)="$event.preventDefault(); toggleExpand(i)" style="color: #1976d2; margin-left: 8px; font-size: 12px; text-decoration: none; cursor: pointer;">
                      Show less
                    </a>
                  </ng-container>
                </ng-container>
                <ng-container *ngIf="(history.displayValue || '').length <= 200">
                  <markdown class="history-markdown" [data]="htmlEscape(history.displayValue || '-')"></markdown>
                </ng-container>
              </div>
            </li>
          </ul>
          <div class="history-row" style="font-size: 10px; display: flex; align-items: center; margin-top: 2px; color: #000;">
            <span style="display: flex; align-items: center;">
              <strong>Updated by:</strong> {{ history.updated_by }}
              <span style="margin-left: 16px;"><strong>Updated at:</strong> {{ history.displayTimestamp || (history.updated_at ? history.updated_at : '-') }}</span>
            </span>
            <span style="margin-left: auto; margin-top: 10px;">
              <ng-container *ngIf="history.previous_confidence !== undefined">
                <span>
                  <ng-container [ngSwitch]="history.previous_confidence">
                    <mat-icon *ngSwitchCase="true" style="color: blue; font-size: medium;">thumb_up</mat-icon>
                    <mat-icon
                      *ngSwitchCase="false"
                      [style.color]="history.category_name === 'AI identified the right document context, but the final answer was PARTIALLY CORRECT' ? '#fbc02d' : '#d32f2f'"
                      style="font-size: medium;"
                    >
                      thumb_down
                    </mat-icon>
                  </ng-container>
                </span>
              </ng-container>
            </span>
          </div>
        </div>
      </li>
    </ul>
  </div>

  <ng-container *ngIf="(!sortedHistory || sortedHistory.length === 0)">
    <div style="color: #888; font-size: 14px;">No history available for this result.</div>
  </ng-container>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button class="cra-button button-light history-close-hover" mat-button mat-dialog-close>Close</button>
</mat-dialog-actions>